import i18n from "i18next";
import { currencyToSymbol } from "./currencyToSymbol";

export default function getPriceForMinDuration(space, t = i18n.t) {
  const currencySymbol = currencyToSymbol(space.currency);
  const chosenDuration = space.minimal_duration;

  // Helper function to check if space is seminar or teambuilding
  const isSeminarOrTeambuilding = (usageKey) => {
    return usageKey === "seminar" || usageKey === "teambuilding";
  };

  // For seminar/teambuilding spaces on the space card, show the LOWEST price from ANY enabled seminar
  if (isSeminarOrTeambuilding(space.placeUsage?.key) && Array.isArray(space.seminars)) {
    const lowestValidPrice = getLowestValidSeminarPrice(space.seminars);
    
    if (lowestValidPrice !== null && lowestValidPrice > 0) {
      const suffix = "/p.";
      const durationKey = `space.by${chosenDuration
        .split("_")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join("")}`;
      
      return `${lowestValidPrice} ${currencySymbol} ${t(durationKey)}${suffix}`;
    }
    
    // If no valid price found
    return `${t("space.priceOnRequest")}`;
  }

  // For non-seminar/teambuilding spaces, use the original logic
  let price;
  
  // Select base price for the chosen duration
  switch (chosenDuration) {
    case "hour":
      price = space.price_hour;
      break;
    case "half_day":
      price = space.price_half_day;
      break;
    case "day":
      price = space.price_day;
      break;
    case "week":
      price = space.price_week;
      break;
    case "month":
      price = space.price_month;
      break;
    default:
      price = null;
  }

  // Handle the special case for residential duration
  if (chosenDuration === "residential" && price && price > 0) {
    return `${price} ${currencySymbol} ${t("space.byDay")}/p.`;
  }

  // Set display suffix
  const suffix = "";

  // Determine output format based on chosen duration and price
  if (chosenDuration && price && price > 0) {
    const durationKey = `space.by${chosenDuration
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join("")}`;
    return `${price} ${currencySymbol} ${t(durationKey)}${suffix}`;
  } else {
    return `${price || 0} ${currencySymbol}`;
  }
}

/**
 * Get the lowest valid price from all enabled seminars (regardless of type)
 * Used for the space card to show the minimum price
 * @param {Array} seminars - Array of seminar objects
 * @returns {number|null} - Lowest valid price or null if none found
 */
function getLowestValidSeminarPrice(seminars) {
  let lowestPrice = null;
  
  seminars.forEach((seminar) => {
    if (seminar.enable === true) {
      const priceValue = seminar.price !== null && seminar.price !== undefined && seminar.price !== "" 
        ? parseFloat(seminar.price) 
        : null;
      
      if (priceValue !== null && !isNaN(priceValue) && priceValue > 0) {
        if (lowestPrice === null || priceValue < lowestPrice) {
          lowestPrice = priceValue;
        }
      }
    }
  });
  
  return lowestPrice;
}